import type {AnyFn} from "Core/types";

// ### ### ###

// TODO automatic type inference
export const pipe = <I = any, O = any>(fns :AnyFn[]) => (i :I) :O =>
  fns.reduce ((acc, fn) => fn.call (fn, acc), i) as O;

